import { Center } from '@euler/components/Center';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import {
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  ViewStyle,
} from 'react-native';
import { Defs, G, LinearGradient, Path, Stop, Svg } from 'react-native-svg';

const kAspectRatio = 92 / 68;

export const CenterTabButton = memo(
  ({
    style,
    onPress,
  }: {
    style?: StyleProp<ViewStyle>;
    onPress?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const height = rpx(48);
    const width = kAspectRatio * height;
    return (
      <TouchableOpacity
        style={style}
        onPress={onPress}
        css={`
          width: ${rpx(96)}px;
          height: 100%;
          justify-content: center;
          align-items: center;
        `}
      >
        <Svg width={width} height={height} viewBox="0 0 92 68" fill="none">
          <Defs>
            <LinearGradient
              x1="17.7636364%"
              y1="26.646281%"
              x2="89.1954545%"
              y2="78.5966942%"
              id="linearGradient-1"
            >
              <Stop stopColor="#009FD4" offset="0%"></Stop>
              <Stop stopColor="#009FD4" offset="44.3%"></Stop>
              <Stop stopColor="#2669db" offset="100%"></Stop>
            </LinearGradient>
          </Defs>
          <G stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <G
              transform="translate(0.1667, 0.6667)"
              fill="url(#linearGradient-1)"
              fillRule="nonzero"
            >
              <Path d="M89.6083333,55.3333333 C88.69375,60 84.8083333,63.55625 80.0083333,64.2229167 C72.4645833,65.3333333 59.8916667,66.6666667 45.71875,66.6666667 C31.775,66.6666667 19.2020833,65.3333333 11.4291667,64.2229167 C6.62916667,63.55625 2.74166667,60 1.82916667,55.3333333 C0.914583333,50.2229167 0,42.6666667 0,33.3333333 C0,24 0.914583333,16.44375 1.82916667,11.3333333 C2.74375,6.66666667 6.62916667,3.11041667 11.4291667,2.44375 C18.9729167,1.33333333 31.5458333,0 45.71875,0 C59.8916667,0 72.2354167,1.33333333 80.0083333,2.44375 C84.8083333,3.11041667 88.6958333,6.66666667 89.6083333,11.3333333 C90.5229167,16.44375 91.6666667,24 91.6666667,33.3333333 C91.4375,42.6666667 90.5229167,50.2229167 89.6083333,55.3333333 Z" />
            </G>
          </G>
        </Svg>
        <Center style={StyleSheet.absoluteFill}>
          <Icon name="plus" size={rpx(28)} color="#fff" />
        </Center>
      </TouchableOpacity>
    );
  },
);
